import { useQuery, useQueryClient, useMutation } from 'react-query';

import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import { getDatasets, addDataset, editDataset, deleteDataset } from './actions';

export const useDatasets = (code, params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-datasets', code, params],
    queryFn: () =>
      getDatasets({ queryKey: ['get-datasets', { ...params, q: code }] }),
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useAddDataset = (code, { onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (payload) => addDataset(code, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['get-datasets', code]);
        toastSuccess('Successfully added dataset!');
        if (typeof onSuccess === 'function') onSuccess();
      },
      onError: (err) => {
        toastError(err?.response?.data?.message);
        if (typeof onError === 'function') onError();
      },
    },
  );
  return [isLoading, mutate];
};

export const useEditDataset = (code, { onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (payload) => editDataset(code, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['get-datasets', code]);
        toastSuccess('Successfully updated dataset!');
        if (typeof onSuccess === 'function') onSuccess();
      },
      onError: (err) => {
        toastError(err?.response?.data?.message);
        if (typeof onError === 'function') onError();
      },
    },
  );
  return [isLoading, mutate];
};

export const useDeleteDataset = (code, { onSuccess, onError }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    (uuid) => deleteDataset(code, uuid),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['get-datasets', code]);
        toastSuccess('Successfully deleted dataset!');
        if (typeof onSuccess === 'function') onSuccess();
      },
      onError: (err) => {
        toastError(err?.response?.data?.message);
        if (typeof onError === 'function') onError();
      },
    },
  );
  return [isLoading, mutate];
};

export default {};
